import { defineNuxtPlugin } from '#imports'
import { useAuthStore } from '@stores/auth'
import { useNowPlayingStore } from '@stores/now-playing'
import { useMemberStore } from '@stores/member'

// Runs after the analytics plugin (02): validating the user calls Mixpanel.
//
// `auth` goes first: it sets the Bearer token the other two fetch with, and `member`
// needs the user it validated. Its validation is not awaited, so the first render
// does not wait on the network.
export function startStores() {
    const authStore = useAuthStore()
    authStore.init()
    useNowPlayingStore().init()
    useMemberStore().init(authStore.currentUser)
}

export default defineNuxtPlugin({
    name: 'stores',
    setup() {
        startStores()
    },
})
